/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsAuthorizeDiscount
 */
export interface IdentityMelcoModelsAuthorizeDiscount {
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsAuthorizeDiscount
     */
    discount_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsAuthorizeDiscount
     */
    final_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsAuthorizeDiscount
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsAuthorizeDiscount
     */
    product_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsAuthorizeDiscount
     */
    amount?: number;
}

export function IdentityMelcoModelsAuthorizeDiscountFromJSON(json: any): IdentityMelcoModelsAuthorizeDiscount {
    return IdentityMelcoModelsAuthorizeDiscountFromJSONTyped(json, false);
}

export function IdentityMelcoModelsAuthorizeDiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsAuthorizeDiscount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'discount_amount': !exists(json, 'discount_amount') ? undefined : json['discount_amount'],
        'final_amount': !exists(json, 'final_amount') ? undefined : json['final_amount'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
    };
}

export function IdentityMelcoModelsAuthorizeDiscountToJSON(value?: IdentityMelcoModelsAuthorizeDiscount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'discount_amount': value.discount_amount,
        'final_amount': value.final_amount,
        'code': value.code,
        'product_code': value.product_code,
        'amount': value.amount,
    };
}


